import React from "react";
import { Outlet } from "react-router-dom";

const BillingScreen = () => {
  return (
    <div className="w-full h-full">
      <Outlet />
    </div>
  );
};

export default BillingScreen;
